export default __webpack_public_path__ + "static/media/person3.9f444ad1.jpg";